//游戏大类
export enum GameEntryEnum {
  casino = "casino",
  sport = "sport",
  lottery = "lottery",
  live = "live",
  bingo = "bingo",
}
//游戏大类-模板
export enum GameEntryTempEnum {
  temp1 = "1",
  temp2 = "2",
  temp3 = "3",
  temp4 = "4",
  temp5 = "5",
}

//游戏导航点击类型
export enum NavsClickType {
  home = 0, //casino首页
  link = 1,
  casino = 2, //casino游戏库
  maker = 3, //casino厂商
}

//游戏导航点击类型
export enum NavsClickNewType {
  home = 0, // casino首页
  gclass = 1, //casino游戏库
  maker_list = 2, //casino厂商
  maker_games = 3, // 厂商游戏
  guess = 4, // 猜你喜欢
}

// 游戏排序
export enum GameSearchSort {
  Popular = "0",
  AZ = "1",
  ZA = "2",
  new = "3",
}
// 流水类型
export enum OPTCodeEnum {
  //100 -199 佣金类
  OPT_CODE_BONUS_EXCHANGE = 1, // 彩金兑入
  OPT_GAME_REBATE_IN = 2, // vip游戏返水
  OPT_PLATFORM_COIN_UNLOCK = 3, // 平台币解锁
  OPT_ADMIN_FREE = 8, // 管理后台赠送
  OPT_SUBSCRIBE_ACTIVITY = 10, // 订阅活动奖励
  OPT_RELIEF_REFUND3_ACTIVITY_BONUS = 15, // 救济金3奖金
  OPT_ACTIVITY_18_BONUS = 16, // 新人转盘
  OPT_ACTIVITY_17_BONUS = 17, // 现金转盘
  OPT_ACTIVITY_15_BONUS = 18, // 神秘礼金奖金
  OPT_ACTIVITY_20_SUPER_BONUS = 19, // 抽卡活动大奖金
  OPT_ACTIVITY_20_BONUS = 20, // 抽卡活动奖金
  OPT_USER_DAILY_VIP_CASH_BACK_ON_LOSSES = 21, // VIP日亏损返现活动
  OPT_USER_TIPS = 24, // TIPS 小费
  OPT_SOURCE_TASK_POINT_IN = 29, // 任务奖励
  OPT_VIP_REWARD = 36, // VIP 升级奖励
  OPT_VIP_MONTHLY_REWARD = 37, // VIP 月福利奖励
  OPT_VIP_DAILY_REWARD = 39, // 翻卡活动 (旧: VIP 日福利奖励)
  OPT_ACTIVITY_23_BONUS = 40, // VIP 日奖金活动
  OPT_ACTIVITY_24_BONUS = 41, // VIP 周反水活动
  OPT_GIFT_CODE_REWARD_MONEY = 48, // 礼包码金币奖励
  OPT_PROMO_ITEM_REWARD_IN = 54, // 优惠道具奖励
  OPT_SEVEN_DATA_CHECK_IN = 56, // 七日签到奖励
  OPT_VIP_WEEK_WELFARE_GIVE = 58, // VIP周奖金奖励
  OPT_BOARD_GIVE = 60, // 打榜奖励
  OPT_TURNTABLE_IN = 61, // 幸运转盘奖励
  OPT_GIVE_REWARD_CFG_IN = 62, // 管理后台发放配置奖励
  OPT_USER_PAY_ACTIVITY = 63, // 存款优惠
  OPT_USER_REGISTER_ACTIVITY = 66, // 注册奖励
  OPT_USER_VIP_CASH_BACK_ON_LOSSES = 67, // VIP亏损返现活动
  OPT_USER_RED_ENVELOPE_RAIN = 68, // 红包雨活动
  OPT_NEW_USER_RED_ENVELOPE_RAIN = 69, // 新红包雨活动
  OPT_GAME_AGENT_REBATE = 70, // 线下代理返水活动
  OPT_EXPERIENCE_PAY_BONUS = 71, // 体验金用户充值额外赠送
  OPT_NEW_USER_SEVEN_DAY_CHECK_IN = 72, // 新人七日签到奖励
  OPT_REALTIME_GAME_REBATE_IN = 73, // 实时vip反水
  OPT_CARNIVAL_BLIND_BOX = 74, // 狂欢节活动
  OPT_CARNIVAL_SHOP_POINT_ORDER = 75, // 狂欢节面具兑换奖品赠送
  OPT_ACTIVITY_26_BONUS = 76, // 活动26下载app奖励活动赠送
  OPT_ACTIVITY_RELIEF = 77, // 救济金（低保）活动
  OPT_ACTIVITY_SUPRISE_PACK = 80, // 惊喜礼包
  OPT_ACTIVITY_SUPRISE_RELIEF_FUND2 = 81, // 救援金2
  OPT_GAME_PROVIDER_PROMO = 82, // 厂商活动奖励,因为不算入投注记录, 所以用赠送
  OPT_GAME_FREE_SPIN = 83, // 自建游戏免费旋转,因为不算入投注记录, 所以用赠送
  OPT_GAME_CHATG_RAINING = 84, // 聊天室下雨 系统发放领取
  OPT_ACTIVITY_56_BONUS = 85, // 新用户累计充值活动奖励
  OPT_ACTIVITY_57_BONUS = 86, // 召回活动奖励
  OPT_LOTTERY_BATTLE_REWARD = 87, // 彩票大战
  OPT_ACTIVITY_58_BONUS = 89, // 召注册转盘活动奖励
  OPT_ACTIVITY_59_BONUS = 90, // 新充值活动
  OPT_ACTIVITY_25_BONUS = 93, // vip月奖金
  OPT_ACTIVITY_7_BONUS = 11, // wj专属注册奖励
  OPT_ACTIVITY_FIRST_PAY = 12, // 新首充活动
  OPT_ACTIVITY_SHAKE = 9, // 摇现金活动
  OPT_ACTIVITY_307_BONUS = 94, // 投注优惠活动
  OPT_ACTIVITY_308_BONUS = 95, // 登录优惠活动
  OPT_GAME_AIDE = 99, // 游戏加成 辅助赠送金币(算赠送)
  OPT_BD_GIVE_MONEY = 92, // BD后台赠送
  OPT_CODE_COMMI = 100,
  OPT_DAY_AGENT_POINT = 101, //全民代理佣金
  OPT_INVITE_NEW_USER_REWARD = 103, // 邀请新用户奖励
  OPT_INVITE_NEW_USER_VIPUP_REWARD = 104, // 邀请新用户-vip升级奖励
  OPT_THIRD_LEVEL_DISTRIBUTION_FLOW = 105, // 分销-佣金奖励
  OPT_THIRD_LEVEL_DISTRIBUTION_RECHARGE = 106, // 分销-充值奖励
  OPT_INVIT_NEW_USER_TREASUREBOX_GIVE = 107, // 宝箱活动奖励
  OPT_CASH_FLOP = 108, // 现金翻牌活动
  OPT_OFFLINE_AGENT_REBATE = 109, // 线下代理返水差佣金
  OPT_UNLIMITED_AGENT_COMMISSION = 110, // 无限级代码
  OPT_ACTIVITY_12_BONUS = 111, // 新邀请转盘奖励
  OPT_ACTIVITY_22_BONUS = 115, // 邀请转盘3奖励
  OPT_DAY_AGENT_POINT2 = 116, //全民代理佣金2
  OPT_ACTIVITY_601_BOX_BONUS = 112, // 团队代理邀请宝箱奖励
  OPT_ACTIVITY_601_REBATE_BONUS = 113, // 团队代理返佣奖励
  OPT_ACTIVITY_601_INVITE_BONUS = 114, // 团队代理邀请奖励
  OPT_ONLINE_RECHARGE = 201, // 线上充值
  OPT_ARTIFICIAL_GIFT = 203, // 人工赠送
}
//钱包类型
export enum WalletType {
  cash = 0,
  bonus = 1,
  point = 3,
}

export enum popupType {
  registerRoulette = 1, // 注册转盘
  experience = 2, // 体验金
  inviteWheelNoLogin = 3, // 邀请转盘未登录
  register = 4, // 新人注册谈窗
  inviteWheelLogin = 5, // 邀请转盘已登录
  newerRegisterRoulette = 6, // 新人注册转盘
  systemPopupLogin = 7, // 系统弹窗
  reliefFund = 8, // 救济金
  jackpot = 9, // jackpot宝藏
  redPocket = 10, // 红包雨
  bottomApp = 11, // 底部APP下载
  webToApp = 12, // APP下载活动
  callback = 13, // 召回奖励
  subscribe = 14, // 订阅活动
  deposit = 15, // 新用户连续充值活动
  registerRouletteLogin = 16, // 注册转盘
  systemPopupNoLogin = 17, // 系统弹窗配置
  inviteeRewardNoLogin = 18, // 团队邀请弹窗配置未登录
  inviteeRewardLogin = 19, // 团队邀请弹窗配置已登录
  registerSuccessPopup = 20, // 注册成功保存信息弹窗
  newUserPromotion = 21, // 新人优惠礼包
  appDownloadNoLogin = 22, // APP下载未登录
  pwaDownloadNoLogin = 23, // PWA下载未登录
  appDownload = 24, // APP下载
  pwaDownload = 25, // PWA下载
  firstDepositNoLogin = 26, // 首存活动未登录
  firstDepositLogin = 27, // 首存活动已登录
  flipCardLogin = 28, // 翻卡活动已登录
  flipCardNoLogin = 29, // 翻卡活动未登录
  vipWeeklyCardLogin = 30, // 超值七日卡 已登陆
  dailyLossBackLogin = 31, // 每日亏损返还活动已登录
  vipDayDeposit = 33, // vip每日首充
}

export enum kycVerifyStatusResult {
  none = 0, //未开始
  pendding = 1, //验证中
  fail = 2, //验证失败
  success = 3, //验证成功
}
